import React, { useState, useEffect, useCallback } from 'react';
import api from '../api/api';

const TABS = ['Calendar', 'Company Settings'];

export default function CalendarSettings() {
  const [tab, setTab] = useState('Calendar');

  return (
    <div className="space-y-4">
      <h1 className="page-title">Administration</h1>

      <div className="card">
        <div className="flex border-b border-sap-border/60">
          {TABS.map((t) => (
            <button
              key={t}
              onClick={() => setTab(t)}
              className={`px-4 py-2.5 text-xs border-b-2 transition-colors
                ${tab === t
                  ? 'border-sap-blue text-sap-blue font-bold bg-white'
                  : 'border-transparent text-sap-textLight hover:text-sap-text hover:bg-sap-blue/5'}`}
            >
              {t}
            </button>
          ))}
        </div>

        <div className="p-4">
          {tab === 'Calendar' && <CalendarTab />}
          {tab === 'Company Settings' && <SettingsTab />}
        </div>
      </div>
    </div>
  );
}

function CalendarTab() {
  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading]   = useState(true);
  const year = new Date().getFullYear();

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const data = await api.get(`/calendar?year=${year}`);
      setHolidays(Array.isArray(data) ? data : []);
    } catch { setHolidays([]); }
    finally { setLoading(false); }
  }, [year]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <span className="text-xs font-semibold text-sap-text">Company Calendar — Non-Working Days ({year})</span>
      </div>
      <div className="data-table-wrap">
        <table className="w-full text-sm">
          <thead>
            <tr className="table-head">
              <th className="text-left px-4 py-3 font-semibold text-2xs uppercase tracking-wider">Date</th>
              <th className="text-left px-4 py-3 font-semibold text-2xs uppercase tracking-wider">Type</th>
              <th className="text-left px-4 py-3 font-semibold text-2xs uppercase tracking-wider">Description</th>
              <th className="text-center px-4 py-3 font-semibold text-2xs uppercase tracking-wider">Recurring</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={4} className="px-4 py-8 text-center text-sap-textLight">Loading…</td></tr>
            ) : holidays.length === 0 ? (
              <tr><td colSpan={4} className="px-4 py-8 text-center text-sap-textLight">No non-working days configured for {year}.</td></tr>
            ) : holidays.map((h) => (
              <tr key={h.date} className="table-row even:bg-gray-50/50">
                <td className="px-4 py-3 font-semibold text-sap-blue">{h.date ? h.date.slice(0, 10) : ''}</td>
                <td className="px-4 py-3">{h.type || 'Holiday'}</td>
                <td className="px-4 py-3">{h.description || ''}</td>
                <td className="px-4 py-3 text-center">{h.recurring ? '✓' : ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function SettingsTab() {
  return (
    <div className="grid grid-cols-2 gap-x-8 gap-y-3 max-w-lg">
      <SettingField label="Default Currency"     placeholder="e.g. INR" />
      <SettingField label="MRP Horizon (days)"   placeholder="e.g. 90" />
      <SettingField label="Default Warehouse"    placeholder="e.g. 1" />
      <SettingField label="Fiscal Year Start"    placeholder="MM-DD" />
      <div className="col-span-2 pt-3">
        <button type="button" className="btn-primary">
          Save Settings
        </button>
      </div>
    </div>
  );
}

function SettingField({ label, placeholder }) {
  return (
    <div className="flex items-center gap-2">
      <label className="w-40 text-xs text-sap-textLight text-right shrink-0">{label}</label>
      <input
        type="text"
        placeholder={placeholder}
        className="flex-1 h-7 px-2 text-xs border border-sap-border rounded
                   focus:outline-none focus:border-sap-blue focus:ring-1 focus:ring-sap-blue/20"
      />
    </div>
  );
}
